import * as React from 'react'

import {
  apptTypeToTitle,
  type IEntityAppointment,
} from '@user/store/scheduling'
import { AppointmentDateTime } from './AppointmentDateTime'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

type ScheduledAppointmentProps = {
  appt: IEntityAppointment
}

export function ScheduledAppointment(props: ScheduledAppointmentProps) {
  const { appt } = props
  const { status, workTime, timeRange, scheduledServices } = appt

  const title = apptTypeToTitle(appt)

  const svcList = scheduledServices === null ? [] : scheduledServices

  return (
    <Stack>
      <Typography variant="subtitle1" fontFamily="Source Sans Pro SemiBold">
        {title}
      </Typography>

      <Stack ml={0.5}>
        <Stack mt={1}>
          {svcList.map((s, i) => (
            <Typography
              key={i}
              variant="body2"
            >{`${s.serviceName} ${s.serviceDescription}`}</Typography>
          ))}
        </Stack>

        <Stack direction="row" mt={1}>
          <Typography variant="subtitle2">Status:&nbsp;</Typography>
          <Typography variant="body2">{status}</Typography>

          <AppointmentDateTime
            ml={4}
            workTime={workTime}
            timeRange={timeRange ?? ''}
          />
        </Stack>
      </Stack>
    </Stack>
  )
}
